import { render } from "./CtaButton.vue?vue&type=template&id=3de0f4ef&scoped=true&ts=true"
import script from "./CtaButton.vue?vue&type=script&lang=ts"
export * from "./CtaButton.vue?vue&type=script&lang=ts"

import "./CtaButton.vue?vue&type=style&index=0&id=3de0f4ef&lang=scss&scoped=true"

import exportComponent from "/home/production/domains/monteur.waterluxe.nl/monteur-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de0f4ef"]])

export default __exports__